export class Cliente {
public idCliente: number;
public Nombre: string;
public razonSocial: string;
public Numero: number;
public Email: string;
public RFC: string;
public fecha: any;
public usuario: number;
public salarioExtra: number;
public loacs: string;
public DEBT: number;
public rfc: string;
public BILL_TAX_REGIME_ID: number;
public BILL_CFDI_USE_ID: number;
}



// WEBPACK FOOTER //
// ./src/app/models/cliente.ts